import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {Dibujo} from './dibujos.state';

export const loadDibujos = createAction(
  '[DIBUJOS] Load Dibujos',
  props<{ dibujos: Dibujo[] }>()
);
export const addDibujo = createAction(
  '[DIBUJOS] Add Dibujo',
  props<{ dibujo: Dibujo }>()
);
export const setDibujo = createAction(
  '[DIBUJOS] Set Dibujo',
  props<{ dibujo: Dibujo }>()
);
export const upsertDibujo = createAction(
  '[DIBUJOS] Upsert Dibujo',
  props<{ dibujo: Dibujo }>()
);
export const addDibujos = createAction(
  '[DIBUJOS] Add Dibujos',
  props<{ dibujos: Dibujo[] }>()
);
export const updateDibujo = createAction(
  '[DIBUJOS] Update Dibujo',
  props<{ update: Update<Dibujo> }>()
);
export const updateDibujos = createAction(
  '[DIBUJOS] Update Dibujos',
  props<{ updates: Update<Dibujo>[] }>()
);
export const deleteDibujo = createAction(
  '[DIBUJOS] Delete Dibujo',
  props<{ id: number }>()
);
export const deleteDibujos = createAction(
  '[DIBUJOS] Delete Dibujos',
  props<{ ids: number[] }>()
);

export const loadingDibujos = createAction(
  '[DIBUJOS] Loading Dibujos',
  props<{ isLoading: boolean, error: string }>()
);


export const clearDibujos = createAction('[DIBUJOS] Clear Dibujos');
